import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { AppEnvironmentState } from 'mbs-ui-shared@models/AppEnvironmentState';

@Injectable({
  providedIn: 'root'
})
export class AppEnvStateService {
  private http = inject(HttpClient);

  public appEnvState = signal<AppEnvironmentState>(null);

  constructor() {
    this.http.get('/api/version').subscribe((appState: AppEnvironmentState) => this.appEnvState.set(appState));
  }
}
